import RachelCSEvents from '@renter-hub/tracking/ClickStreamEvents';
import {
  PAGE_BILLING_ADDRESS_ACH,
  PAGE_BILLING_ADDRESS_CARD,
  PAGE_CARD_INPUT,
  PAGE_PAYMENT_TYPE_SELECTION,
} from './pageFlows';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

export function trackPaymentContinue(
  user: ZrmClickstreamUser,
  currentPage: string,
  modeOfPayment: string,
  listingAlias?: string,
) {
  switch (currentPage) {
    case PAGE_PAYMENT_TYPE_SELECTION:
      return RachelCSEvents.emitClickContinueFromPaymentSelectionPageEvent({
        user,
        triggerSource: `continue_selected_payment_${modeOfPayment}`,
      });
    case PAGE_CARD_INPUT:
      return RachelCSEvents.emitClickContinueFromCardDetailsPageEvent({
        user,
        triggerSource: `continue_${modeOfPayment}`,
        currentProperty: { listingAlias },
      });
    case PAGE_BILLING_ADDRESS_ACH:
    case PAGE_BILLING_ADDRESS_CARD:
      return RachelCSEvents.emitClickContinueFromAddressPageEvent({ user });
    default:
      return null;
  }
}

export function trackPaymentBack(user: ZrmClickstreamUser, currentPage: string) {
  switch (currentPage) {
    case PAGE_CARD_INPUT:
      return RachelCSEvents.emitClickBackButtonEvent({ user, triggerObject: 'payment_info_card_details_page' });
    case PAGE_BILLING_ADDRESS_ACH:
    case PAGE_BILLING_ADDRESS_CARD:
      return RachelCSEvents.emitClickBackButtonEvent({ user, triggerObject: 'payment_info_address_page' });
    default:
      return null;
  }
}
